import { useDiagnosisFormat } from 'features/Procedure/hooks/useDiagnosisFormat'

type Props = {
  justifyCodes: string[]
}

export const Diagnosis = ({ justifyCodes }: Props) => {
  const { diagnosisFormat } = useDiagnosisFormat({ justifyCodes, historical: true })
  return <div>{diagnosisFormat.join(',')}</div>
}
